// Hindi. Recipe text itself stays in English for Hindi readers (recipes are written in Tamil,
// English and Tanglish), so search examples use English words.
import type { Key } from '../i18n';

export const hi: Record<Key, string> = {
  'nav.main': 'मुख्य',
  'nav.home': 'होम',
  'nav.albums': 'एल्बम',
  'nav.grocery': 'किराना',
  'nav.home.label': 'Eat Recipe होम',
  'common.tryAgain': 'फिर से कोशिश करें',
  'common.tryingAgain': 'फिर से कोशिश कर रहे हैं…',
  'common.back': 'वापस',
  'common.cancel': 'रद्द करें',
  'common.save': 'सेव करें',
  'common.done': 'हो गया',
  'common.loading': 'लोड हो रहा है',
  'common.seeAll': 'सभी देखें',
  'common.addReel': 'रील जोड़ें',
  'common.profile': 'सेटिंग्स और प्रोफ़ाइल',
  'common.watchReel': 'रील देखें ↗',
  'common.veg': 'शाकाहारी',
  'common.nonveg': 'मांसाहारी',
  'common.unsure': 'पता नहीं',
  'n.recipes_one': '{n} रेसिपी',
  'n.recipes': '{n} रेसिपी',
  'n.ingredients_one': '{n} सामग्री',
  'n.ingredients': '{n} सामग्री',
  'n.steps_one': '{n} स्टेप',
  'n.steps': '{n} स्टेप',
  'n.cooked': '{n}× बनाया',
  'n.cookedOn': '{n}× बनाया · {date}',
  'verdict.again': 'फिर से बनाएँगे',
  'verdict.ok': 'ठीक था',
  'verdict.no': 'हमारे लिए नहीं',

  'lang.title': 'अपनी भाषा चुनें',
  'lang.body': 'ऐप के शब्द और Instagram बॉट के जवाब इसी भाषा में होंगे। सेटिंग्स में कभी भी बदलें।',
  'lang.ta': 'रेसिपी और ऐप तमिल में',
  'lang.en': 'रेसिपी और ऐप अंग्रेज़ी में',
  'lang.tg': 'thakkali, vengayam जैसे नाम · ऐप अंग्रेज़ी में',
  'lang.continue': 'आगे बढ़ें',
  'lang.saveFailed': 'आपकी भाषा सेव नहीं हो सकी। कनेक्शन जाँचें और फिर कोशिश करें।',

  'greet.tiffin': 'सुप्रभात{name} · नाश्ते का समय',
  'greet.lunch': 'नमस्ते{name} · दोपहर के खाने का समय',
  'greet.teatime': 'शुभ संध्या{name} · चाय का समय',
  'greet.dinner': 'शुभ संध्या{name} · रात के खाने का समय',
  'greet.latenight': 'देर रात{name} · कुछ झटपट?',
  'home.title': 'आज क्या खाने का मन है?',
  'home.search': '{n} रेसिपी में खोजें · tomato · rasam',
  'home.searchEmpty': 'खोजें · tomato · rasam',
  'home.mood': 'मन है…',
  'home.surprise': 'तय नहीं कर पा रहे? कुछ भी सुझाओ',
  'home.howAbout': 'ये कैसा रहेगा…',
  'home.cookThis': 'चलो इसे बनाते हैं',
  'home.another': 'कोई और',
  'home.cookAgain': 'फिर से बनाएँ',
  'home.cookAgainHint': 'आपने कहा था “फिर से बनाएँगे”',
  'home.yourAlbums': 'आपके एल्बम',
  'home.justSaved': 'अभी सेव किए',
  'home.allByDate': 'तारीख के अनुसार सभी',
  'home.readingFrom': '{who} की रील पढ़ रहे हैं',
  'home.reading': 'रील पढ़ रहे हैं',
  'home.landsInAlbums': 'तैयार होते ही सही एल्बम में जाएगी',
  'home.addedTo': '{albums} में जोड़ा गया',
  'home.noRecipe': 'इस रील में कोई रेसिपी नहीं मिली',
  'home.failed': 'यह रील नहीं पढ़ सके · फिर से कोशिश के लिए टैप करें',
  'home.newTitle': 'आपकी रेसिपी यहाँ आएँगी, मन के हिसाब से छँटी हुई',
  'home.newBody': 'Instagram में किसी भी कुकिंग रील पर ➤ टैप करें और @eat.recipe को भेजें। एक मिनट में रेसिपी यहाँ होगी।',
  'home.openInstagram': '@eat.recipe को मैसेज करें',
  'home.pasteLink': 'इसके बजाय रील का लिंक पेस्ट करें',
  'reason.never_tried': 'सेव किया, कभी नहीं बनाया',
  'reason.make_again_days': 'आपने कहा फिर से बनाएँगे · {n} दिन पहले',
  'reason.make_again_weeks': 'आपने कहा फिर से बनाएँगे · {n} हफ़्ते पहले',
  'reason.not_cooked_days': '{n} दिन से नहीं बनाया',
  'reason.not_cooked_weeks': '{n} हफ़्ते से नहीं बनाया',
  'reason.meal.tiffin': 'नाश्ते के लिए अच्छा',
  'reason.meal.lunch': 'दोपहर के खाने के लिए अच्छा',
  'reason.meal.teatime': 'चाय के साथ अच्छा',
  'reason.meal.dinner': 'रात के खाने के लिए अच्छा',
  'reason.meal.latenight': 'देर रात के लिए झटपट',
  'surprise.none': 'अभी सुझाने के लिए कुछ नहीं है।',

  'albums.title': 'एल्बम',
  'albums.sub': '{n} रेसिपी, आते ही आपके लिए छाँटी गईं',
  'albums.sub_one': '1 रेसिपी, आते ही आपके लिए छाँटी गई',
  'albums.search': 'सभी रेसिपी खोजें',
  'albums.mine': 'आपके बनाए',
  'albums.new': 'नया एल्बम',
  'albums.browse': 'ऐसे देखें',
  'albums.view': 'एल्बम व्यू',
  'view.craving': 'मन',
  'view.region': 'इलाका',
  'view.meal': 'भोजन',
  'view.timeline': 'टाइमलाइन',
  'hint.craving': 'मन के हिसाब से चुनें — तीखा, सुकून भरा, झटपट या हल्का।',
  'hint.region': 'जगह का स्वाद — चेट्टिनाड की रसोई से दुनिया भर की थाली तक।',
  'hint.meal': 'अभी कौन सा समय है? नाश्ते से रात के खाने तक, और लंचबॉक्स भी।',
  'hint.timeline': 'आपकी शेयर की हर रील, सेव करने के क्रम में।',
  'albums.empty': 'अभी यहाँ कुछ नहीं है। @eat.recipe को कुछ रील भेजें, वे अपने आप एल्बम में छँट जाएँगी।',
  'tl.week': 'इस हफ़्ते',
  'tl.month_rest': 'इस महीने पहले',
  'tl.before': 'उससे पहले',
  'tl.reading': '{n} पढ़ी जा रही हैं…',

  'kind.craving': 'मन',
  'kind.region': 'इलाका',
  'kind.meal': 'भोजन',
  'kind.mine': 'आपका एल्बम',
  'album.stats': '{n} रेसिपी · {c} बनाई · {u} अभी नहीं बनाई',
  'album.stats_one': '1 रेसिपी · {c} बनाई · {u} अभी नहीं बनाई',
  'album.pin': 'होम पर पिन करें',
  'album.unpin': 'होम से हटाएँ',
  'album.pinned': 'होम पर पिन किया',
  'album.unpinned': 'होम से हटाया',
  'album.backToAlbums': 'एल्बम पर वापस',
  'filter.label': 'रेसिपी फ़िल्टर करें',
  'filter.all': 'सभी',
  'filter.untried': 'अभी नहीं बनाई',
  'album.pick': 'इनमें से मेरे लिए एक चुनो',
  'album.favourites': 'आपकी पसंदीदा',
  'album.notTried': 'अभी नहीं बनाई',
  'album.cookedBefore': 'पहले बनाई',
  'album.saved': '{date} को सेव की',
  'album.shop': 'इनमें से कुछ के लिए खरीदारी करें',
  'album.shopTitle': 'आप कौन-सी बना रहे हैं?',
  'album.shopGo': 'किराना सूची बनाएँ · {n}',
  'album.empty': 'अभी यहाँ कोई रेसिपी नहीं।',
  'album.emptyMine': 'कोई रेसिपी खोलें और “एल्बम में जोड़ें” टैप करें।',
  'album.noMatch': 'इस फ़िल्टर से कुछ नहीं मिला।',
  'album.showAll': 'सभी दिखाएँ',
  'album.rename': 'नाम बदलें',
  'album.delete': 'एल्बम हटाएँ',
  'album.deleteConfirm': 'हटाने के लिए फिर टैप करें — रेसिपी आपकी लाइब्रेरी में रहेंगी',
  'album.notFound': 'यह एल्बम अब मौजूद नहीं है।',
  'album.nameLabel': 'एल्बम का नाम',
  'album.namePlaceholder': 'माँ के तरीके से · रविवार स्पेशल',
  'album.create': 'एल्बम बनाएँ',
  'album.created': 'एल्बम बन गया',

  'timeline.title': 'तारीख के अनुसार सभी',
  'timeline.newest': 'नई पहले',
  'timeline.search': 'रेसिपी खोजें',
  'timeline.empty': 'आपकी लाइब्रेरी खाली है',
  'timeline.emptyBody': 'Instagram में किसी भी कुकिंग रील पर ➤ टैप करें और @eat.recipe को भेजें। रेसिपी कुछ ही पलों में यहाँ आ जाएगी।',
  'timeline.noMatch': 'इस फ़िल्टर से कुछ नहीं मिला।',
  'timeline.showAll': 'सभी दिखाएँ',
  'timeline.retrying': 'फिर से कोशिश कर रहे हैं — रेसिपी यहाँ आएगी',
  'timeline.scriptHint': 'नाम {script} में; बदलने के लिए टैप करें',

  'card.reading': 'रील पढ़ रहे हैं',
  'card.arrives': 'रेसिपी कुछ ही पलों में आएगी',
  'card.progress': 'प्रोसेसिंग की प्रगति',
  'card.stages': 'मिल गई · सुन रहे हैं · लिख रहे हैं',
  'card.failed': 'यह रील नहीं पढ़ सके',
  'card.linkSafe': 'आपका लिंक सुरक्षित है।',
  'card.private': 'रील प्राइवेट है या हटा दी गई है।',
  'card.dropped': 'सुनते समय कनेक्शन टूट गया।',
  'card.wrong': 'सुनते समय कुछ गड़बड़ हो गई।',
  'card.noRecipe': 'इस रील में रेसिपी नहीं है',
  'card.noRecipeBody': 'इसमें एक डिश की बात है, पर बनाने का तरीका नहीं दिखाया। हमने लिंक आपके लिए रख लिया है।',
  'card.ingredientsOnly': 'केवल सामग्री — रील में स्टेप नहीं बताए गए',
  'card.taVoice': 'तमिल आवाज़',
  'card.enVoice': 'अंग्रेज़ी आवाज़',

  'add.title': 'रील जोड़ें',
  'add.label': 'Instagram रील का लिंक पेस्ट करें',
  'add.adding': 'जोड़ रहे हैं…',
  'add.submit': 'मेरी लाइब्रेरी में जोड़ें',
  'add.or': 'या, Instagram में कोई भी रील यहाँ शेयर करें',
  'add.added': 'मिल गई — रील पढ़ रहे हैं',

  'search.label': 'रेसिपी खोजें',
  'search.back': 'वापस',
  'search.clear': 'खोज साफ़ करें',
  'search.also': 'यह भी खोज रहे हैं',
  'search.count_one': '1 रेसिपी',
  'search.count': '{n} रेसिपी',
  'search.idle': 'डिश, सामग्री या क्रिएटर से अपनी रेसिपी खोजें।',
  'search.none': 'कुछ नहीं मिला?',
  'search.tryScripts': 'अंग्रेज़ी शब्दों से खोजें — जैसे tomato या rasam। रेसिपी तमिल, अंग्रेज़ी और Tanglish में लिखी जाती हैं।',
  'match.dish': 'डिश का नाम मिला',
  'match.ingredient': 'सामग्री:',
  'match.transcript': 'रील में कहा गया:',
  'match.caption': 'कैप्शन:',
  'match.tag': '“{t}” टैग',
  'match.creator': '{t} से',
  'match.similar': 'मिलती-जुलती वर्तनी',

  'recipe.notInLibrary': 'यह रेसिपी आपकी लाइब्रेरी में नहीं है।',
  'recipe.share': 'रेसिपी शेयर करें',
  'recipe.copied': 'लिंक कॉपी हुआ',
  'recipe.reelLength': '{d} की रील',
  'recipe.taVoice': 'तमिल आवाज़',
  'recipe.enVoice': 'अंग्रेज़ी आवाज़',
  'recipe.cookedLast': '{n}× बनाया · आख़िरी बार {date}',
  'recipe.today': 'आज',
  'recipe.from': 'इनकी रील से रेसिपी',
  'recipe.cookMode': 'कुक मोड',
  'recipe.addGrocery': 'किराना सूची में जोड़ें',
  'recipe.inGrocery': 'आपकी किराना सूची में ✓',
  'recipe.groceryAdded': 'किराना सूची में जोड़ा',
  'recipe.groceryRemoved': 'किराना सूची से हटाया',
  'swipe.add': 'किराना में जोड़ें',
  'swipe.remove': 'किराने से हटाएँ',
  'grocery.swipeHint': 'सुझाव: किसी रेसिपी को दाईं ओर स्वाइप करें, वह यहाँ जुड़ जाएगी।',
  'recipe.playReel': 'रील यहीं चलाएँ',
  'recipe.fullScreen': 'फ़ुल स्क्रीन',
  'recipe.closeReel': 'रील बंद करें',
  'recipe.addAlbum': 'एल्बम में जोड़ें',
  'recipe.inAlbums_one': '1 एल्बम में',
  'recipe.inAlbums': '{n} एल्बम में',
  'recipe.script': 'रेसिपी की लिपि',
  'recipe.ingredients': 'सामग्री',
  'recipe.inHand': '{total} में से {n} पास में',
  'recipe.steps': 'बनाने की विधि',
  'recipe.tgSteps': 'स्टेप केवल अंग्रेज़ी और तमिल में आते हैं — अंग्रेज़ी दिखा रहे हैं।',
  'recipe.noSteps': 'रील में स्टेप नहीं बताए गए — तरीके के लिए रील देखें।',
  'recipe.caption': 'क्रिएटर का कैप्शन',
  'recipe.says': 'रील में क्या कहा गया',
  'recipe.rough': 'रील से अपने आप लिखा गया; कहीं-कहीं कच्चा हो सकता है।',
  'recipe.noRecipe': 'इस रील में कोई रेसिपी नहीं मिली।',
  'recipe.readingTitle': 'रेसिपी कुछ ही पलों में यहाँ आएगी',
  'recipe.failedBody': 'आपका लिंक सुरक्षित है। फिर से कोशिश करना अक्सर काम करता है।',
  'recipe.remove': 'मेरी लाइब्रेरी से हटाएँ',
  'recipe.removeConfirm': 'हटाने के लिए फिर टैप करें',
  'recipe.removeNote': 'इस रेसिपी के आपके नोट्स भी हट जाएँगे।',
  'recipe.removeKeep': 'जिन्होंने इसे सेव किया है, उनके लिए रेसिपी बनी रहेगी।',
  'albumSheet.title': 'एल्बम में जोड़ें',
  'albumSheet.none': 'आपने अभी कोई एल्बम नहीं बनाया।',
  'albumSheet.added': '{name} में जोड़ा',
  'albumSheet.removed': '{name} से हटाया',
  'notes.title': 'मेरे रसोई नोट्स',
  'notes.private': 'केवल आप',
  'notes.cookedToday': 'आज बनाया ✓',
  'notes.cookToday': 'मैंने आज यह बनाया',
  'notes.logged_one': 'दर्ज हुआ · कुल 1 बार · वापस लेने के लिए फिर टैप करें',
  'notes.logged': 'दर्ज हुआ · कुल {n} बार · वापस लेने के लिए फिर टैप करें',
  'notes.cookedBefore_one': 'एक बार बनाया · आख़िरी बार {date}',
  'notes.cookedBefore': '{n} बार बनाया · आख़िरी बार {date}',
  'notes.notYet': 'अभी नहीं बनाया',
  'notes.turnOut': 'कैसा बना?',
  'notes.next': 'अगली बार के लिए नोट',
  'notes.placeholder': 'मिर्च कम, एक टमाटर और…',
  'notes.save': 'नोट सेव करें',
  'notes.delete': 'नोट हटाएँ',
  'notes.today': 'आज',

  'cook.exit': 'बाहर',
  'cook.awake': 'स्क्रीन चालू रहेगी',
  'cook.keepOn': 'स्क्रीन चालू रखें',
  'cook.switch': 'स्टेप की भाषा बदलें',
  'cook.progress': 'स्टेप की प्रगति',
  'cook.step': 'स्टेप',
  'cook.forStep': 'इस स्टेप के लिए',
  'cook.prev': 'पिछला स्टेप',
  'cook.next': 'अगला स्टेप',
  'cook.noSteps': 'इस रेसिपी में साथ-साथ बनाने के लिए स्टेप नहीं हैं।',
  'cook.backToRecipe': 'रेसिपी पर वापस',

  'grocery.title': 'किराना सूची',
  'grocery.summary': '{n} चीज़ें · {b} थैले में · {r} रेसिपी से',
  'grocery.summary_one': '{n} चीज़ें · {b} थैले में · 1 रेसिपी से',
  'grocery.addRecipes': '+ रेसिपी',
  'grocery.emptyTitle': 'अभी खरीदने को कुछ नहीं',
  'grocery.emptyBody': 'कोई रेसिपी खोलें और “किराना सूची में जोड़ें” टैप करें। अलग-अलग रेसिपी की एक जैसी सामग्री एक ही लाइन में जुड़ जाती है।',
  'grocery.bringBack': '{n} रेसिपी वापस लाएँ',
  'grocery.bringBack_one': '1 रेसिपी वापस लाएँ',
  'grocery.goRecipes': 'मेरी रेसिपी पर जाएँ',
  'grocery.remove': '{dish} हटाएँ',
  'grocery.skipped': '{n} रेसिपी में अभी सामग्री सूची नहीं है।',
  'grocery.skipped_one': '1 रेसिपी में अभी सामग्री सूची नहीं है।',
  'grocery.hidePantry': 'घर की आम चीज़ें छिपाएँ',
  'grocery.hidden': '{n} छिपी: {names}',
  'grocery.nothingHidden': 'छिपाने को कुछ नहीं',
  'grocery.showingBasics': 'नमक, तेल और दूसरी आम चीज़ें दिखा रहे हैं',
  'grocery.vegetables': 'सब्ज़ियाँ',
  'grocery.spices': 'मसाले',
  'grocery.others': 'अन्य',
  'grocery.nRecipes': '{n} रेसिपी',
  'grocery.asNeeded': 'ज़रूरत के अनुसार',
  'grocery.copy': 'सूची कॉपी करें',
  'grocery.copied': 'कॉपी हुई — कहीं भी पेस्ट करें',
  'grocery.copyFailed': 'इस डिवाइस पर कॉपी नहीं हो सकी',
  'grocery.whatsapp': 'WhatsApp पर शेयर करें',
  'grocery.later': 'किराना ऐप से ऑर्डर — जल्द आ रहा है',
  'grocery.textTitle': 'किराना सूची — Eat Recipe',

  'settings.title': 'सेटिंग्स',
  'settings.account': 'आपका अकाउंट',
  'settings.via': 'Instagram DM से साइन इन',
  'settings.language': 'भाषा',
  'settings.languageHint': 'ऐप और बॉट के जवाब। रेसिपी अंग्रेज़ी में दिखती हैं।',
  'settings.saved': 'सेव हुआ',
  'settings.install': 'होम स्क्रीन पर जोड़ें',
  'settings.installBody': 'ऐप की तरह खुलता है और साइन इन रहता है।',
  'settings.installIOS': 'Safari में Share टैप करें, फिर “Add to Home Screen”।',
  'settings.installBtn': 'Eat Recipe जोड़ें',
  'install.later': 'अभी नहीं',
  'install.android': 'ब्राउज़र मेनू (⋮) में “Install app” या “Add to Home screen” टैप करें।',
  'settings.privacy': 'प्राइवेसी पॉलिसी ↗',
  'settings.deletion': 'आपका डेटा कैसे हटाया जाता है ↗',
  'settings.signOut': 'साइन आउट',
  'settings.delete': 'मेरा अकाउंट हटाएँ',
  'settings.deleteConfirm': 'सब कुछ हटाने के लिए फिर टैप करें',
  'settings.deleteNote': 'आपकी लाइब्रेरी, नोट्स, एल्बम और बनाने का इतिहास हमेशा के लिए हट जाएगा।',
  'settings.deleteKeep': 'दूसरों की सेव की गई रेसिपी उनके लिए बनी रहेंगी।',
  'order.groceryTitle': '{app} पर ऑर्डर करें',
  'order.cartTitle': 'आपका {app} कार्ट',
  'order.connectTitle': 'अपना {app} अकाउंट जोड़ें',
  'order.connectBody': 'आप अपने फ़ोन नंबर से {app} पर साइन इन करते हैं। फिर Eat Recipe इस सूची से आपका {app} कार्ट भरता है; भुगतान {app} में होता है।',
  'order.connect': '{app} जोड़ें',
  'order.connectFailed': '{app} जोड़ना पूरा नहीं हुआ। कृपया फिर कोशिश करें।',
  'order.emptyList': 'आपकी किराना सूची खाली है।',
  'order.finding': '{app} पर आपकी चीज़ें ढूँढ रहे हैं…',
  'order.pickHint': 'हर चीज़ का पैक चुनें। घर में मौजूद आम चीज़ें छोड़ दी गई हैं।',
  'order.recipeNeeds': 'रेसिपी में चाहिए {q}',
  'order.pantry': 'अक्सर घर में होता है',
  'order.notFound': '{app} पर नहीं मिला',
  'order.pack': 'पैक',
  'order.quantity': 'मात्रा',
  'order.less': 'एक कम',
  'order.more': 'एक और',
  'order.build': 'मेरा {app} कार्ट भरें · {n} चीज़ें',
  'order.build_one': 'मेरा {app} कार्ट भरें · 1 चीज़',
  'order.building': 'आपका कार्ट भर रहे हैं…',
  'order.payInApp': 'कीमतें {app} की हैं और चेकआउट पर बदल सकती हैं। डिलीवरी का समय और भुगतान {app} में चुनें।',
  'order.openToPay': 'भुगतान के लिए {app} खोलें',
  'order.cartReady': 'आपका कार्ट तैयार है — चेकआउट के लिए {app} ऐप खोलें।',
  'order.editItems': 'चीज़ें बदलें',
  'food.title': '{app} पर ऑर्डर करें',
  'food.connectBody': 'आप अपने फ़ोन नंबर से {app} पर साइन इन करते हैं। Eat Recipe यह डिश पास में ढूँढता है और आपकी पुष्टि के बाद ही ऑर्डर करता है।',
  'food.deliverTo': 'यहाँ डिलीवर करें',
  'food.address': 'पता',
  'food.change': 'बदलें',
  'food.noAddress': '{app} पर कोई सेव पता नहीं है। पहले {app} ऐप में पता जोड़ें।',
  'food.dish': 'डिश का नाम',
  'food.search': 'खोजें',
  'food.none': 'अभी {app} पर पास के किसी रेस्टोरेंट में यह नहीं है।',
  'food.soldOut': 'खत्म हो गया',
  'food.customizable': 'विकल्प चुनने होंगे — यह {app} ऐप में ऑर्डर करें',
  'food.review': 'ऑर्डर देखें',
  'food.reviewTitle': 'अपना ऑर्डर देखें',
  'food.payWith': 'भुगतान का तरीका',
  'food.noPayment': 'यहाँ इस ऑर्डर के लिए {app} कोई भुगतान तरीका नहीं देता।',
  'food.note': 'रेस्टोरेंट के लिए नोट (वैकल्पिक)',
  'food.notePlaceholder': 'कम तीखा, बिना प्याज़…',
  'food.cancelNote': 'ऑर्डर सीधे रेस्टोरेंट को जाते हैं। कैश ऑर्डर यहाँ रद्द नहीं हो सकते; ज़रूरत हो तो {app} सपोर्ट से संपर्क करें।',
  'food.choosePayment': 'भुगतान का तरीका चुनें',
  'food.place': 'ऑर्डर करें · {total} · {method}',
  'food.placing': 'आपका ऑर्डर कर रहे हैं…',
  'food.doneTitle': 'आपका ऑर्डर',
  'food.placed': '{app} ऑर्डर हो गया',
  'food.orderId': 'ऑर्डर {id}',
  'food.eta': '{eta} में पहुँचेगा',
  'food.refresh': 'स्थिति देखें',
  'food.payNow': 'अपने UPI ऐप में भुगतान करें',
  'food.payBody': 'भुगतान होते ही ऑर्डर {app} पर हो जाएगा।',
  'food.openUPI': 'UPI ऐप खोलें',
  'food.waiting': 'भुगतान का इंतज़ार…',
  'food.failed': 'ऑर्डर नहीं हो सका',
  'recipe.orderIt': 'बनाना नहीं है? {app} पर ऑर्डर करें',
  'grocery.orderOn': '{app} पर ऑर्डर करें',
  'settings.apps': 'ऑर्डर करने वाले ऐप',
  'settings.appsHint': 'किराना सूची से कार्ट भरने या डिश ऑर्डर करने के लिए कोई ऐप जोड़ें।',
  'settings.connected': 'जुड़ा हुआ',
  'settings.connect': 'जोड़ें',
  'settings.disconnect': 'हटाएँ',
  'settings.appConnected': '{app} जुड़ गया',
  'settings.appDisconnected': '{app} हटाया गया',
  'settings.grocery': 'किराना',
  'settings.food': 'खाना डिलीवरी',
  'apps.title': 'यह किराना ऑर्डर करें',
  'apps.sub': '{n} रेसिपी से। ऑर्डर के लिए ऐप चुनें।',
  'apps.sub_one': '1 रेसिपी से। ऑर्डर के लिए ऐप चुनें।',
  'apps.none': 'इस सर्वर पर अभी कोई किराना ऐप सेट नहीं है।',
  'apps.signIn': 'अपने फ़ोन नंबर से साइन इन करें',
  'apps.note': 'Eat Recipe ऐप का कार्ट भरता है और उसी की कीमतें दिखाता है। आपकी पुष्टि के बिना कुछ ऑर्डर नहीं होता।',
  'soon.badge': 'जल्द आ रहा है',
  'soon.orderOn': '{apps} पर ऑर्डर करें',
  'soon.body': '{app} के Eat Recipe को मंज़ूरी देते ही यहाँ से ऑर्डर कर पाएँगे।',
  'grocery.orderAll': 'यह किराना ऑर्डर करें',
  'order.connectBody2': 'आप अपने फ़ोन नंबर से {app} पर साइन इन करते हैं। फिर Eat Recipe इस सूची से कार्ट बनाता है और {app} की कीमतें दिखाता है; आपकी पुष्टि के बिना कुछ ऑर्डर नहीं होता।',
  'order.reviewN': 'ऑर्डर देखें · {n} चीज़ें',
  'order.reviewN_one': 'ऑर्डर देखें · 1 चीज़',
  'order.notDeliverable': '{app} अभी इस पते पर यह कार्ट डिलीवर नहीं कर सकता।',
  'order.realOrder': 'यह आपके {app} कार्ट की चीज़ों को बदल देगा। ऑर्डर असली है: {app} इसे डिलीवर करेगा और आपके चुने तरीके से पैसे लेगा।',
  'order.payTitle': 'ऑर्डर पूरा करने के लिए भुगतान करें',
  'order.payNow': 'भुगतान पेज खोलें',
  'order.finishInApp': '{app} ऐप में पूरा करें',
  'order.finishInAppNote': 'आपका कार्ट पहले से {app} में है: वहाँ और जोड़ें, कूपन लगाएँ और भुगतान करें।',
  'order.cancelInApp': 'रद्द करना है? {app} ऐप खोलें (ऑर्डर {id})। बिना भुगतान के ऑर्डर डिलीवर नहीं होते।',
  'order.pickedOf': '{total} में से {n} चुनी',
  'order.basicsLeftOut': 'घर की आम चीज़ें छोड़ दी गईं',
  'order.include': '{item} शामिल करें',
  'order.otherPacks': 'दूसरे पैक',
  'order.itemsFeesNext': '{n} चीज़ें · शुल्क अगले स्टेप में',
  'order.itemsFeesNext_one': '1 चीज़ · शुल्क अगले स्टेप में',
  'food.dishesNear': 'आपके पास {n} डिश',
  'food.dishesNear_one': 'आपके पास 1 डिश',
  'food.add': 'जोड़ें',
  'food.soldOutShort': 'खत्म',
  'food.optionsInApp': 'विकल्प {app} में',
  'food.oneItem': '{n} चीज़ें · {total}',
  'food.oneItem_one': '1 चीज़ · {total}',
  'order.payInApp2': 'इस ऑर्डर का भुगतान पूरा करने के लिए {app} ऐप खोलें।',
  'order.checkFirst': 'फिर से कोशिश करने से पहले {app} ऐप में अपने ऑर्डर देखें, ताकि दो बार ऑर्डर न हो।',

  'search.placeholder': 'tomato · rasam · dosa',
  'script.ta': 'तमिल',
  'script.en': 'अंग्रेज़ी',
  'script.tg': 'Tanglish',
  'cook.done': 'हो गया',
  'recipe.contentLang': 'रेसिपी तमिल, अंग्रेज़ी और Tanglish में लिखी जाती हैं।',
  'auth.checking': 'आपका लिंक जाँच रहे हैं…',
  'auth.isYou': 'क्या यह आप हैं?',
  'auth.yourAccount': 'आपका अकाउंट',
  'auth.linkFrom': 'यह लिंक {h} के साथ आपकी चैट से आया है। यह एक ही बार काम करता है, इसलिए कोई और इससे आपकी लाइब्रेरी नहीं खोल सकता।',
  'auth.continueAs': '{who} के रूप में आगे बढ़ें',
  'auth.notYou': 'आप नहीं हैं? अपना लिंक पाएँ',
  'auth.opening': 'आपकी लाइब्रेरी खोल रहे हैं…',
  'auth.used': 'यह लिंक पहले ही इस्तेमाल हो चुका है',
  'auth.usedBody': 'हर लिंक आपकी लाइब्रेरी एक बार, थोड़े समय के लिए खोलता है। नया लिंक कुछ ही सेकंड में मिल जाता है।',
  'auth.stepOpen': '{h} के साथ अपनी चैट खोलें',
  'auth.stepSend': '{w} भेजें और नया लिंक टैप करें',
  'auth.newLink': 'नया लिंक पाएँ',
  'auth.safe': 'आपकी सेव की गई रेसिपी सुरक्षित हैं — कुछ नहीं खोया।',
  'auth.checkFailed': 'हम आपका लिंक नहीं जाँच सके',
  'auth.checkConn': 'कृपया कनेक्शन जाँचें और फिर कोशिश करें।',
  'auth.hello': 'नमस्ते,',
  'auth.friend': 'दोस्त',
  'auth.summaryEmpty': '@eat.recipe को कोई कुकिंग रील शेयर करें, वह यहाँ आ जाएगी।',
  'auth.summary': 'आपके DM से {n} रेसिपी सेव हुईं।',
  'auth.summary_one': 'आपके DM से 1 रेसिपी सेव हुई।',
  'auth.reading': '{n} अभी पढ़ी जा रही हैं।',
  'auth.reading_one': '1 अभी पढ़ी जा रही है।',
  'auth.installBody': 'ऐप की तरह खुलता है, साइन इन रहता है, मोबाइल डेटा कम लेता है।',
  'auth.openLibrary': 'मेरी लाइब्रेरी खोलें',
  'signin.bubble': 'यह रहा आपका एक बार का लिंक। लाइब्रेरी खोलने के लिए टैप करें →',
  'signin.title': 'आपकी रेसिपी आपके DM में इंतज़ार कर रही हैं',
  'signin.step1': 'Instagram में {h} खोलें',
  'signin.step2': '{w} शब्द भेजें',
  'signin.step3': 'हमारे भेजे लिंक को टैप करें। पासवर्ड कभी नहीं।',
  'signin.message': '@eat.recipe को मैसेज करें',
  'signin.have': 'लिंक पहले से है? इसे इसी फ़ोन पर खोलें, आप अंदर होंगे।',
};
